/**
 * Full-area overlay displayed when files are dragged over the chat area.
 * Provides visual feedback for drag-and-drop file attachment.
 */
import { UploadIcon } from 'lucide-react'
import { type FC, memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ChatDropZoneOverlayProps {
  isDragOver: boolean
  className?: string
}

const ChatDropZoneOverlayBase: FC<ChatDropZoneOverlayProps> = ({
  isDragOver,
  className,
}): ReactNode => {
  if (!isDragOver) return null

  return (
    <div
      className={cn(
        'chat-drop-zone-overlay absolute inset-0 z-50 flex items-center justify-center',
        'bg-background/80 backdrop-blur-sm',
        'animate-in fade-in duration-200',
        className
      )}
    >
      <div className="flex flex-col items-center gap-3 rounded-xl border-2 border-dashed border-primary/50 bg-primary/5 px-12 py-10">
        <UploadIcon className="size-10 text-primary/70" />
        <p className="text-lg font-medium text-primary/90">Drop files here</p>
        <p className="text-sm text-muted-foreground">Attach files to your message</p>
      </div>
    </div>
  )
}

export const ChatDropZoneOverlay = memo(ChatDropZoneOverlayBase)

ChatDropZoneOverlay.displayName = 'ChatDropZoneOverlay'
